import { app } from '../../../../../app';
import { Controller } from './move-accounts.controller';

app.component('companyUserDirectoriesManageUserMoveAccounts', {
    bindings: {
        accounts: '<',
        accountsForCompanyUser: '<',
        companyId: '<',
        companyUser: '<',
    },
    controller: Controller,
    templateUrl: require('./move-accounts.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/manage-user/move-accounts/move-accounts.component.js